// Configuration centralisée de l'API
export const API_CONFIG = {
  // URL de base de l'API
  BASE_URL: (import.meta as any).env?.VITE_API_BASE_URL || 'http://localhost:8000/api/v1',
  
  // Version de l'API
  API_VERSION: 'v1',
  
  // Endpoints principaux
  ENDPOINTS: {
    // Sites et multi-tenancy
    SITES: {
      LIST: '/sites/',
      TENANTS: '/sites/tenants/',
      SWITCH: '/sites/switch/',
      ACTIVE: '/sites/active/',
      MY_SITES: '/sites/my-sites/',
      CREATE: '/sites/create/',
      STATISTICS: '/sites/statistics/',
      BLOCK: (id: number) => `/sites/${id}/block/`,
      UNBLOCK: (id: number) => `/sites/${id}/unblock/`,
    },
    
    // Authentification et utilisateurs
    AUTH: {
      USERS: '/users/',
      LOGIN: '/auth/token/',
      REFRESH: '/auth/token/refresh/',
      LOGOUT: '/auth/logout/',
      ROLES: '/auth/roles/',
    },
    
    // Ponts bascule
    PONT_BASCULE: {
      LIST: '/pont-bascule/ponts-bascule/',
      BY_SITE: (siteId: string) => `/pont-bascule/ponts-bascule/by_site/?site_id=${siteId}`,
      DETAIL: (id: string) => `/pont-bascule/ponts-bascule/${id}/`,
      CREATE: '/pont-bascule/ponts-bascule/',
      UPDATE: (id: string) => `/pont-bascule/ponts-bascule/${id}/`,
      DELETE: (id: string) => `/pont-bascule/ponts-bascule/${id}/`,
      RESET_API_SECRET: (id: string) => `/pont-bascule/ponts-bascule/${id}/reset_api_secret_key/`,
      SET_AS_DEFAULT: (id: string) => `/pont-bascule/ponts-bascule/${id}/set_as_default/`,
      STATISTICS: (id: string) => `/pont-bascule/ponts-bascule/${id}/statistics/`,
      PROCESS_AGENT_RETURN: (id: string) => `/pont-bascule/ponts-bascule/${id}/process_agent_return/`,
      AGENT_RETURNS: (id: string) => `/pont-bascule/ponts-bascule/${id}/agent_returns/`,
      LATEST_AGENT_RETURN: (id: string) => `/pont-bascule/ponts-bascule/${id}/latest_agent_return/`,
    },
    
    // Pesées
    WEIGHING: {
      STATISTICS: '/weighing/api/statistics/',
      TICKETS: '/weighing/api/weighing-tickets/',
      PENDING_TARE: '/weighing/api/weighing-tickets/pending-tare/',
    },
    
    // Notifications
    NOTIFICATIONS: {
      STATS: '/notifications/stats/',
    },
  },
  
  // Headers par défaut
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },
  
  // Timeout des requêtes (en millisecondes)
  TIMEOUT: 30000,
  
  // Configuration des retry
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000,
  },
};

// Fonction utilitaire pour construire l'URL complète
export const buildApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Fonction utilitaire pour obtenir l'URL de base de l'API
export const getApiBaseUrl = (): string => {
  return API_CONFIG.BASE_URL;
};

// Configuration des environnements
export const ENV_CONFIG = {
  DEVELOPMENT: {
    API_BASE_URL: 'http://localhost:8000/api/v1',
    LOG_LEVEL: 'debug',
  },
  STAGING: {
    API_BASE_URL: 'https://api.staging.ci/api/v1',
    LOG_LEVEL: 'info',
  },
  PRODUCTION: {
    API_BASE_URL: 'https://api.cita.ci/api/v1',
    LOG_LEVEL: 'warn',
  },
};

// Détection automatique de l'environnement
export const getCurrentEnvironment = (): keyof typeof ENV_CONFIG => {
  const hostname = window.location.hostname;
  
  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return 'DEVELOPMENT';
  } else if (hostname.includes('staging')) {
    return 'STAGING';
  } else {
    return 'PRODUCTION';
  }
};

// Configuration dynamique basée sur l'environnement
export const getDynamicConfig = () => {
  const env = getCurrentEnvironment();
  return {
    ...API_CONFIG,
    BASE_URL: ENV_CONFIG[env].API_BASE_URL,
    LOG_LEVEL: ENV_CONFIG[env].LOG_LEVEL,
  };
};
